import { createReducer, on } from "@ngrx/store";
import { ApuStandardResourceActions } from "./apu-standard-resource.actions";
import { apuStandardResourceAdapter } from "./apu-standard-resource.state";
import { initialApuStandardCategory } from "./apu-standard-resource.state";

export const apuStandardResourceReducer = createReducer(
    initialApuStandardCategory,
    on(ApuStandardResourceActions.loadApuStandardResourceSuccess, (state, action) => {
        return apuStandardResourceAdapter.setAll(action.apuStandardResources, {
            ...state,
            errorMessage: null
        });
    })
);